export default "__VITE_ASSET__c1e5c20d__"